import { render, staticRenderFns } from "./Freefield.vue?vue&type=template&id=4f4742f6&"
import script from "./Freefield.vue?vue&type=script&lang=ts&"
export * from "./Freefield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports